
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.642.892c.54-1.15 2.176-1.15 2.716 0l2.01 4.284a1.5 1.5 0 001.131.845l4.616.706c1.206.184 1.7 1.656.846 2.53l-3.432 3.518a1.5 1.5 0 00-.407 1.29l.797 4.886c.201 1.236-1.11 2.16-2.206 1.555L11.726 18.3a1.5 1.5 0 00-1.452 0l-3.987 2.205c-1.096.605-2.407-.319-2.206-1.555l.797-4.887a1.5 1.5 0 00-.407-1.289L1.04 9.257c-.853-.874-.36-2.346.846-2.53L6.5 6.02a1.5 1.5 0 001.13-.845L9.643.892z","fill":"#FBAC2B"}})])
          )
        }
      }
    